import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useLocation } from '@/shared/hooks/useLocation';
import { payersApi } from '../api/payersApi';
import { payerKeys, setupKeys } from '../queryKeys';

export function usePayers() {
  const { currentLocation } = useLocation();
  const locationId = currentLocation?.id ?? '';
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: payerKeys.list(locationId),
    queryFn: () => payersApi.listLocationPayers(locationId),
    enabled: !!locationId,
  });

  function invalidate() {
    queryClient.invalidateQueries({ queryKey: payerKeys.list(locationId) });
    queryClient.invalidateQueries({ queryKey: setupKeys.readiness(locationId) });
  }

  const removePayer = useMutation({
    mutationFn: (locationPayerId: string) =>
      payersApi.removeLocationPayer(locationPayerId, locationId),
    onSuccess: invalidate,
  });

  return { ...query, payers: query.data ?? [], locationId, invalidate, removePayer };
}
